<template>
  <div class="box">
    <!-- 封面图 -->
    <div class="cover"></div>
    <!-- 产品名称  价格 -->
    <div class="Product-Name">
      <p>洪驰供应链管理公司logo设计</p>
      <p>￥ 5000</p>
    </div>
    <!-- 案例标签 -->
    <div class="title">
      <p>案例标签</p>
    </div>
    <div class="CaseTagArr">
      <p v-for="(item, index) in CaseTagArr" :key="index">{{ item }}</p>
    </div>
    <!-- 服务内容 -->
    <div class="title">
      <p>服务内容</p>
    </div>
    <div class="Service-Content">
      <table cellspacing="0" cellpadding="0">
        <tr v-for="(item, index) in serviceArr" :key="index">
          <td
            style="background: #eeeeee"
            v-if="item.tweColumn == ''"
            colspan="2"
          >
            {{ item.oneColumn }}
          </td>
          <td style="background: #eeeeee" v-else>{{ item.oneColumn }}</td>
          <td style="background: #eeeeee" v-if="item.tweColumn != ''">
            {{ item.tweColumn }}
          </td>
          <td style="background: rgba(97, 144, 232, 0.2)">
            {{ item.threeColumn }}
          </td>
          <td style="background: rgba(255, 162, 0, 0.2)">
            {{ item.fourColumn }}
          </td>
          <td style="background: rgba(254, 87, 74, 0.2)">
            {{ item.fiveColumn }}
          </td>
        </tr>
        <tr>
          <td style="background: #eeeeee" colspan="2">服务购买</td>
          <td style="background: rgba(97, 144, 232, 0.2)">
            <div class="Buy">
              <p>立即沟通</p>
              <p>购买</p>
            </div>
          </td>
          <td style="background: rgba(255, 162, 0, 0.2)">
            <div class="Buy">
              <p>立即沟通</p>
              <p>购买</p>
            </div>
          </td>
          <td style="background: rgba(254, 87, 74, 0.2)">
            <div class="Buy">
              <p>立即沟通</p>
              <p>购买</p>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <!-- 服务详情 -->
    <div class="title">
      <p>服务详情</p>
    </div>
    <p class="ServiceDetails">
      创意无限，品质至上！我们的宣传册设计服务，为您的品牌量身打造独特魅力。从构思到呈现，每一步都充满匠心与热情。
      让您的宣传册成为市场中的亮点，吸引更多目光。选择我们，让您的品牌故事在精美的设计中绽放光彩！
    </p>
    <div class="Details-picture"></div>
    <!-- 成功案例 -->
    <div class="title">
      <p>成功案例</p>
    </div>
    <div class="case-box">
      <Case
        :listArr="listArr1"
        :distinguish="2"
        @handelEditCase="handelEditCase"
      ></Case>
    </div>
    <!-- 分页 -->
    <div class="paging-box">
      <div class="paging">
        <paging
          :pagingObj="pagingObj"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
    </div>
    <!-- 评论 -->
    <div class="title">
      <p>评论</p>
      <div class="mark">
        本服务评分：
        <div class="star" v-for="(item, index) in mark" :key="index + 1"></div>
        <div
          class="null"
          v-for="(item, index) in 5 - mark"
          :key="index + 10"
        ></div>
        <span>4 星</span>
      </div>
      <div class="mark">
        平均评分：
        <div class="star" v-for="(item, index) in mark" :key="index + 1"></div>
        <div
          class="null"
          v-for="(item, index) in 5 - mark"
          :key="index + 10"
        ></div>
        <span>4 星</span>
      </div>
    </div>
    <div class="case-box">
      <Review :listArr="listArr" :distinguish="2"></Review>
    </div>
    <!-- 分页 -->
    <div class="paging-box">
      <div class="paging">
        <paging
          :pagingObj="paging"
          @handleCurrentChange="handleCurrent"
        ></paging>
      </div>
    </div>
  </div>
</template>

<script>
import Case from "../../HelpShop/moduleTwe/components/Case.vue"; // 案例信息
import Review from "../../HelpShop/moduleSix/components/Review.vue"; // 评论
import paging from "../../../../../components/paging.vue"; // 分页
export default {
  props: {},
  data() {
    return {
      CaseTagArr: ["企业名称变更", "公司地址变更", "工商年报"], //案例标签
      listArr1: [
        {
          choose: false, //选择 0未  1是
        },
        {
          choose: false, //选择 0未  1是
        },
        {
          choose: false, //选择 0未  1是
        },
      ], // 案例信息
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 6, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 案例分页数据
      paging: {
        currentPage: 1, //当前页
        pageSize: 6, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 评论分页数据
      mark: 4,
      listArr: [
        {
          status: 0,
          mark: 4,
          EvaluationTag: [
            {
              name: "准时守信",
              id: "1",
            },
            {
              name: "值得推荐",
              id: "2",
            },
          ],
        },
        {
          status: 1,
          mark: 3,
          EvaluationTag: [
            {
              name: "准时守信",
              id: "1",
            },
            {
              name: "值得推荐",
              id: "2",
            },
          ],
        },
        {
          status: 0,
          mark: 4,
          EvaluationTag: [
            {
              name: "准时守信",
              id: "1",
            },
            {
              name: "值得推荐",
              id: "2",
            },
          ],
        },
      ], // 评论数据
      serviceArr: [
        {
          oneColumn: "服务版本",
          tweColumn: "",
          threeColumn: "基础版",
          fourColumn: "升级版",
          fiveColumn: "超级版",
        },
        {
          oneColumn: "价格",
          tweColumn: "",
          threeColumn: "￥ 2888",
          fourColumn: "￥ 3888",
          fiveColumn: "￥ 4888",
        },
        {
          oneColumn: "服务亮点",
          tweColumn: "",
          threeColumn:
            " 高端大气、国际化设计风格，多样化设计形式，设计思路广，可提供各行业不同的需求服务，专属名片形象设计，精美品质展示。",
          fourColumn:
            " 高端大气、国际化设计风格，多样化设计形式，设计思路广，可提供各行业不同的需求服务，专属名片形象设计，精美品质展示。",
          fiveColumn:
            " 高端大气、国际化设计风格，多样化设计形式，设计思路广，可提供各行业不同的需求服务，专属名片形象设计，精美品质展示。",
        },
        {
          oneColumn: "服务方式",
          tweColumn: "全程一对一服务",
          threeColumn: "-",
          fourColumn: "-",
          fiveColumn: "-",
        },
        {
          oneColumn: "服务方式",
          tweColumn: "独立小组完成",
          threeColumn: "-",
          fourColumn: "-",
          fiveColumn: "-",
        },
        {
          oneColumn: "服务人员",
          tweColumn: "项目经理",
          threeColumn: "-",
          fourColumn: "1名",
          fiveColumn: "1名",
        },
        {
          oneColumn: "服务人员",
          tweColumn: "产品经理",
          threeColumn: "1名",
          fourColumn: "1名",
          fiveColumn: "1名",
        },
        {
          oneColumn: "服务人员",
          tweColumn: "UI设计",
          threeColumn: "1名",
          fourColumn: "1名",
          fiveColumn: "1名",
        },
        {
          oneColumn: "服务人员",
          tweColumn: "前端开发",
          threeColumn: "1名",
          fourColumn: "2名",
          fiveColumn: "3名",
        },
        {
          oneColumn: "服务人员",
          tweColumn: "后端开发",
          threeColumn: "1名",
          fourColumn: "3名",
          fiveColumn: "4名",
        },
        {
          oneColumn: "服务人员",
          tweColumn: "测试",
          threeColumn: "-",
          fourColumn: "-",
          fiveColumn: "1名",
        },
        {
          oneColumn: "一期交付",
          tweColumn: "原型图",
          threeColumn: "-",
          fourColumn: "-",
          fiveColumn: "-",
        },
        {
          oneColumn: "一期交付",
          tweColumn: "UI设计图",
          threeColumn: "-",
          fourColumn: "-",
          fiveColumn: "-",
        },
        {
          oneColumn: "二期交付",
          tweColumn: "web网站",
          threeColumn: "-",
          fourColumn: "-",
          fiveColumn: "-",
        },
        {
          oneColumn: "二期交付",
          tweColumn: "测试文档",
          threeColumn: "-",
          fourColumn: "-",
          fiveColumn: "-",
        },
        {
          oneColumn: "预计交付时间",
          tweColumn: "独立小组完成",
          threeColumn: "25天",
          fourColumn: "18天",
          fiveColumn: "13天",
        },
        // {
        //   oneColumn: "服务购买",
        //   tweColumn: "独立小组完成",
        //   threeColumn: "-",
        //   fourColumn: "-",
        //   fiveColumn: "-",
        // },
      ],
    };
  },
  components: {
    // 案例
    Case,
    // 分页
    paging,
    // 评论
    Review,
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    // 点击案例模块
    handelEditCase(val) {
      this.$emit("handelEditCase", val);
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
    },
    // 评论分页
    handleCurrent(val) {
      this.paging.currentPage = val;
    },
  },
};
</script>

<style scoped lang="less">
//
.box {
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Medium;
  font-weight: 400;
  color: #666666;
  // 标题
  .title {
    width: 100%;
    height: 25px;
    line-height: 25px;
    display: flex;
    margin: 40px 0px 30px 0px;
    p {
      min-width: 80px;
      height: 100%;
      background-image: url("../../../../../assets/imgs/zhuangshi@3x.svg");
      background-size: 100% 40%;
      background-repeat: no-repeat;
      background-position-y: bottom;
      font-size: 18px;
      color: #333333;
      text-align: center;
    }
    .mark {
      min-width: 100px;
      display: flex;
      margin-left: 40px;
      .star {
        width: 15px;
        height: 14px;
        background-image: url("../../../../../assets/imgs/shoucang@3x.svg");
        background-size: 100% 100%;
        margin: auto 0;
        margin-right: 2px;
      }
      .null {
        width: 15px;
        height: 14px;
        background-image: url("../../../../../assets/imgs/shoucang-null@3x.svg");
        background-size: 100% 100%;
        margin: auto 0;
        margin-right: 2px;
      }
      span {
        margin-left: 5px;
      }
    }
  }
  // 封面
  .cover {
    width: 601px;
    height: 270px;
    background: #eeeeee;
    margin: 0 auto;
  }
  // 产品名  价格
  .Product-Name {
    width: 601px;
    height: 25px;
    line-height: 25px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    p {
      font-size: 20px;
      color: #333333;
    }
    p:nth-child(2) {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      font-size: 26px;
      color: #fe574a;
    }
  }
  // 案例标签
  .CaseTagArr {
    width: 100%;
    min-height: 35px;
    line-height: 35px;
    display: flex;
    flex-wrap: wrap;
    p {
      min-width: 110px;
      height: 33px;
      background: rgba(97, 144, 232, 0.2);
      border: 1px solid #409eff ;
      border-radius: 5px;
      font-size: 12px;
      color: #409eff ;
      text-align: center;
      margin-right: 20px;
    }
  }
  // 服务内容
  .Service-Content {
    width: 100%;
    min-height: 200px;
    // border: 1px solid gold;
    table {
      width: 1120px;
      min-height: 40px;
      tr td {
        padding: 10px;
        font-size: 12px;
      }
      tr {
        width: 100%;
      }
      td {
        width: 24%;
        text-align: center;
        border: 1px solid gray;
      }
      tr td:nth-child(1) {
        width: 14%;
      }
      tr td:nth-child(2) {
        width: 14%;
      }
      .Buy {
        display: flex;
        p {
          width: 110px;
          height: 28px;
          line-height: 28px;
          background: #409eff ;
          border: 1px solid #409eff ;
          border-radius: 5px;
          font-size: 12px;
          color: #ffffff;
          margin: auto;
        }
      }
    }
  }
  // 服务详情
  .ServiceDetails {
    width: 1140px;
    font-size: 12px;
    color: #333333;
    line-height: 30px;
    text-indent: 28px;
  }
  .Details-picture {
    width: 601px;
    height: 270px;
    background: #eeeeee;
    margin: 0 auto;
    margin-top: 20px;
  }
  // 案例信息
  .case-box {
    width: 1140px;
    min-height: 150px;
  }
}
// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 0px;
  display: flex;
  justify-content: flex-end;
  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
